export default "__VITE_ASSET__06b9dd7c__"